import { useMutation } from '@tanstack/react-query'

import { updateUserRequest } from '~services'
import { UserUpdateInput, UserResponse } from '~types/user'

export function useUpdateUser() {
  const {
    mutateAsync: updateUser,
    isLoading: isUpdatingUser,
    isError: isUpdateUserError,
    error,
  } = useMutation<UserResponse, unknown, UserUpdateInput>(updateUserRequest, {
    onError: (e) => {
      return e
    },
    onSuccess: (data) => {
      return data
    },
  })
  return { updateUser, isUpdatingUser, isUpdateUserError, error }
}
